import React from "react";
import Grid from '@mui/material/Grid2';
import { useTranslation } from "react-i18next";
import { Device } from "@services/devices/types";
import PaperDevice from "../PaperDevice";
import { useContext } from "react";
import { FormContext } from "../../context/formContext";

type TroubleshootingProps = {};

const Troubleshooting = (props: TroubleshootingProps) => {
  const { t } = useTranslation();
  const { form } = useContext(FormContext);
  const { ticket } = form;

  const displayPaperDevice = (device: Device) => {
    return <PaperDevice device={device}></PaperDevice>;
  };

  const displayDeviceTroubleshooting = () => {
    if (ticket.device) {
      return <Grid>{displayPaperDevice(ticket.device)}</Grid>;
    } else if (ticket.room?.devices) {
      <Grid>
        {ticket.room.devices.map((device) => {
          return displayPaperDevice(device);
        })}
      </Grid>;
    }
    return <></>;
  };

  return (
    <Grid
      container
      sx={(theme) => ({
        padding: theme.spacing(2, 4),
        flexDirection: "column",
      })}
      spacing={2}
    >
      <Grid>
        <Grid>{t("Troubleshooting")}</Grid>
      </Grid>
      <Grid>
        <Grid
          container
          spacing={1}
          sx={{ width: '100%', flexDirection: "column", }}
        >
          {displayDeviceTroubleshooting()}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Troubleshooting;
